import { Injectable } from '@angular/core';
import { AdminApiClient } from '@/lib-backend';
import { SessionAdminApiClient } from '@/lib-backend/SessionAdminApiClient';
import { IHttpTransport } from '@/lib-backend/core/types';
import { environment } from '@/environments/environment';

/** Fetch transport that disables browser/CDN caching */
const noCacheTransport: IHttpTransport = {
    async post(url: string, body: unknown, headers: Record<string, string>): Promise<unknown> {
        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                ...headers,
            },
            body: JSON.stringify(body),
            cache: 'no-store',
        });
        return response.json();
    },
};

@Injectable({ providedIn: 'root' })
export class ApiService {
    readonly client = new SessionAdminApiClient(environment.apiBaseUrl, noCacheTransport);
    /** Direct client without session management — use for pre-session calls (e.g. token refresh on startup). */
    readonly rawClient = new AdminApiClient(environment.apiBaseUrl, noCacheTransport);
}
